export default "* Hvad betyder det at koncentrere sig?\n* Hvad betyder det at samarbejde?\n* Hvordan er jeg en god legekammerat?";